{
	"title": "Impressum",
	"backTitle": "Tillbaka",
	"company": {
		"name": "HDigital GmbH",
		"address": {
			"street": "Berliner Strasse 6",
			"city": "69120 Heidelberg",
			"country": "Tyskland"
		},
		"contact": {
			"telephone": "Telefon: +49 6221 481-0",
			"telefax": "Telefax: +49 6221 481-13553",
			"email": "E-post: info@heidelbergmaterials.com"
		},
		"legal": {
			"registeredOffice": "Bolagets säte: Heidelberg",
			"commercialRegister": "Handelsregister: Mannheim, HRB 741878",
			"managingDirectors": "Verkställande direktörer:",
			"directors": {
				"rene": "René Aldach",
				"roland": "Roland Sterr",
				"noman": "Noman Ahmed"
			}
		}
	}
}
